export default __webpack_public_path__ + "static/media/CarImages.PegasSmall.fb6e7d7a.jpg";